import { render, staticRenderFns } from "./AssociatedProducts.vue?vue&type=template&id=d58265b4&scoped=true"
import script from "./AssociatedProducts.vue?vue&type=script&lang=js"
export * from "./AssociatedProducts.vue?vue&type=script&lang=js"
import style0 from "./AssociatedProducts.vue?vue&type=style&index=0&id=d58265b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58265b4",
  null
  
)

export default component.exports